import mmcogg from '../../assets/images/tko_icons_svg/mmcogg.svg'
import mmcogr from '../../assets/images/tko_icons_svg/mmcogr.svg'
import mmcogy from '../../assets/images/tko_icons_svg/mmcogy.svg'
import mmcogn from '../../assets/images/tko_icons_svg/mmcogn.svg'

import mmcoyg from '../../assets/images/tko_icons_svg/mmcoyg.svg'
import mmcoyr from '../../assets/images/tko_icons_svg/mmcoyr.svg'
import mmcoyy from '../../assets/images/tko_icons_svg/mmcoyy.svg'
import mmcoyn from '../../assets/images/tko_icons_svg/mmcoyn.svg'

import mpsgg from '../../assets/images/tko_icons_svg/mpsgg.svg'
import mpsgr from '../../assets/images/tko_icons_svg/mpsgr.svg'
import mpsgy from '../../assets/images/tko_icons_svg/mpsgy.svg'
import mpsgn from '../../assets/images/tko_icons_svg/mpsgn.svg'

import mpsyg from '../../assets/images/tko_icons_svg/mpsyg.svg'
import mpsyr from '../../assets/images/tko_icons_svg/mpsyr.svg'
import mpsyy from '../../assets/images/tko_icons_svg/mpsyy.svg'
import mpsyn from '../../assets/images/tko_icons_svg/mpsyn.svg'

import object_utilgg from '../../assets/images/tko_icons_svg/object_utilgg.svg'
import object_utilgr from '../../assets/images/tko_icons_svg/object_utilgr.svg'
import object_utilgy from '../../assets/images/tko_icons_svg/object_utilgy.svg'
import object_utilgn from '../../assets/images/tko_icons_svg/object_utilgn.svg'
import object_utilyg from '../../assets/images/tko_icons_svg/object_utilyg.svg'
import object_utilyr from '../../assets/images/tko_icons_svg/object_utilyr.svg'
import object_utilyy from '../../assets/images/tko_icons_svg/object_utilyy.svg'
import object_utilyn from '../../assets/images/tko_icons_svg/object_utilyn.svg'
import object_utilgo from '../../assets/images/tko_icons_svg/object_utilgo.svg'
import object_utilyo from '../../assets/images/tko_icons_svg/object_utilyo.svg'

import all2gg from '../../assets/images/tko_icons_svg/all2gg.svg'
import all2gn from '../../assets/images/tko_icons_svg/all2gn.svg'
import all2gr from '../../assets/images/tko_icons_svg/all2gr.svg'
import all2gy from '../../assets/images/tko_icons_svg/all2gy.svg'
import all2yg from '../../assets/images/tko_icons_svg/all2yg.svg'
import all2yn from '../../assets/images/tko_icons_svg/all2yn.svg'
import all2yr from '../../assets/images/tko_icons_svg/all2yr.svg'
import all2yy from '../../assets/images/tko_icons_svg/all2yy.svg'

const tkoIconSize = [35, 42]
// [left, top]
const tkoIconAnchor = [16, 20]

export let tkoTypeStatusLoadingIconMap = {
  mmcogg: L.icon({
    iconSize: tkoIconSize,
    iconUrl: mmcogg,
    iconAnchor: tkoIconAnchor,
  }),
  mmcogr: L.icon({
    iconSize: tkoIconSize,
    iconUrl: mmcogr,
    iconAnchor: tkoIconAnchor,
  }),
  mmcogy: L.icon({
    iconSize: tkoIconSize,
    iconUrl: mmcogy,
    iconAnchor: tkoIconAnchor,
  }),
  mmcogn: L.icon({
    iconSize: tkoIconSize,
    iconUrl: mmcogn,
    iconAnchor: tkoIconAnchor,
  }),

  mmcoyg: L.icon({
    iconSize: tkoIconSize,
    iconUrl: mmcoyg,
    iconAnchor: tkoIconAnchor,
  }),
  mmcoyr: L.icon({
    iconSize: tkoIconSize,
    iconUrl: mmcoyr,
    iconAnchor: tkoIconAnchor,
  }),
  mmcoyy: L.icon({
    iconSize: tkoIconSize,
    iconUrl: mmcoyy,
    iconAnchor: tkoIconAnchor,
  }),
  mmcoyn: L.icon({
    iconSize: tkoIconSize,
    iconUrl: mmcoyn,
    iconAnchor: tkoIconAnchor,
  }),

  mpsgg: L.icon({
    iconSize: tkoIconSize,
    iconUrl: mpsgg,
    iconAnchor: tkoIconAnchor,
  }),
  mpsgr: L.icon({
    iconSize: tkoIconSize,
    iconUrl: mpsgr,
    iconAnchor: tkoIconAnchor,
  }),
  mpsgy: L.icon({
    iconSize: tkoIconSize,
    iconUrl: mpsgy,
    iconAnchor: tkoIconAnchor,
  }),
  mpsgn: L.icon({
    iconSize: tkoIconSize,
    iconUrl: mpsgn,
    iconAnchor: tkoIconAnchor,
  }),

  mpsyg: L.icon({
    iconSize: tkoIconSize,
    iconUrl: mpsyg,
    iconAnchor: tkoIconAnchor,
  }),
  mpsyr: L.icon({
    iconSize: tkoIconSize,
    iconUrl: mpsyr,
    iconAnchor: tkoIconAnchor,
  }),
  mpsyy: L.icon({
    iconSize: tkoIconSize,
    iconUrl: mpsyy,
    iconAnchor: tkoIconAnchor,
  }),
  mpsyn: L.icon({
    iconSize: tkoIconSize,
    iconUrl: mpsyn,
    iconAnchor: tkoIconAnchor,
  }),

  object_utilgg: L.icon({
    iconSize: tkoIconSize,
    iconUrl: object_utilgg,
    iconAnchor: tkoIconAnchor,
  }),
  object_utilgr: L.icon({
    iconSize: tkoIconSize,
    iconUrl: object_utilgr,
    iconAnchor: tkoIconAnchor,
  }),
  object_utilgy: L.icon({
    iconSize: tkoIconSize,
    iconUrl: object_utilgy,
    iconAnchor: tkoIconAnchor,
  }),
  object_utilgn: L.icon({
    iconSize: tkoIconSize,
    iconUrl: object_utilgn,
    iconAnchor: tkoIconAnchor,
  }),
  object_utilgo: L.icon({
    iconSize: tkoIconSize,
    iconUrl: object_utilgo,
    iconAnchor: tkoIconAnchor,
  }),
  object_utilyg: L.icon({
    iconSize: tkoIconSize,
    iconUrl: object_utilyg,
    iconAnchor: tkoIconAnchor,
  }),
  object_utilyr: L.icon({
    iconSize: tkoIconSize,
    iconUrl: object_utilyr,
    iconAnchor: tkoIconAnchor,
  }),
  object_utilyy: L.icon({
    iconSize: tkoIconSize,
    iconUrl: object_utilyy,
    iconAnchor: tkoIconAnchor,
  }),
  object_utilyn: L.icon({
    iconSize: tkoIconSize,
    iconUrl: object_utilyn,
    iconAnchor: tkoIconAnchor,
  }),
  object_utilyo: L.icon({
    iconSize: tkoIconSize,
    iconUrl: object_utilyo,
    iconAnchor: tkoIconAnchor,
  }),
  all2gg: L.icon({
    iconSize: tkoIconSize,
    iconUrl: all2gg,
    iconAnchor: tkoIconAnchor,
  }),
  all2gn: L.icon({
    iconSize: tkoIconSize,
    iconUrl: all2gn,
    iconAnchor: tkoIconAnchor,
  }),
  all2gr: L.icon({
    iconSize: tkoIconSize,
    iconUrl: all2gr,
    iconAnchor: tkoIconAnchor,
  }),
  all2gy: L.icon({
    iconSize: tkoIconSize,
    iconUrl: all2gy,
    iconAnchor: tkoIconAnchor,
  }),

  all2yg: L.icon({
    iconSize: tkoIconSize,
    iconUrl: all2yg,
    iconAnchor: tkoIconAnchor,
  }),
  all2yn: L.icon({
    iconSize: tkoIconSize,
    iconUrl: all2yn,
    iconAnchor: tkoIconAnchor,
  }),
  all2yr: L.icon({
    iconSize: tkoIconSize,
    iconUrl: all2yr,
    iconAnchor: tkoIconAnchor,
  }),
  all2yy: L.icon({
    iconSize: tkoIconSize,
    iconUrl: all2yy,
    iconAnchor: tkoIconAnchor,
  }),
}

import cityIconDistribSvg from '../../assets/images/icons/mapLegend/loc-distrib.svg'
import cityIconNotDistribSvg from '../../assets/images/icons/mapLegend/loc-notdistrib.svg'

export let cityIconDistrib = L.icon({
  iconSize: [20, 20],
  iconUrl: cityIconDistribSvg,
  iconAnchor: [10, 10],
})
export let cityIconNotDistrib = L.icon({
  iconSize: [20, 20],
  iconUrl: cityIconNotDistribSvg,
  iconAnchor: [10, 10],
})
